import { useEffect } from "react";

export const useAutoAlert = (message, setMessage, duration = 3000) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [message, setMessage, duration]);
};
